export interface Data {
  month: string
  count: string
}

export function getMonthName(month: number): string {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]

  return monthNames[month]
}
export function processData(data: Data[]): [number[], string[]] {
  const counts: number[] = []
  const months: string[] = []

  data.forEach((item) => {
    const date = new Date(item.month)
    const monthName = getMonthName(date.getMonth())
    months.push(monthName)
    counts.push(parseInt(item.count))
  })

  return [counts.reverse(), months.reverse()]
}

// export function calculatePercentage(
//   policies: { status: string; count: string }[],
//   category: string
// ): number {
//   const total = policies.reduce((acc, policy) => acc + Number(policy.count), 0)
//   const categoryCount =
//     policies.find((policy) => policy.status === category)?.count || '0'

//   const percentage = total > 0 ? (Number(categoryCount) / total) * 100 : 0
//   return Number(percentage.toFixed(0)) //
// }
export function calculatePercentage(
  policies: { [key: string]: number },
  category: string
): string {
  const total = Object.values(policies).reduce((acc, count) => acc + count, 0)
  const categoryCount = policies[category] || 0

  const percentage = total > 0 ? (categoryCount / total) * 100 : 0
  return percentage.toFixed(0) // Format to 2 decimal places
}
